import React from "react";
import styles from "./ItemLocalization.module.scss";
import ItemLocalizationSummary from "../ItemLocalizationSummary";
import Tag from "components/MainApp/organisms/OrdersV3/Tag";
import i18n from "i18n";

const ItemLocalization = ({ item, type, quantity, handleDelete }) => {
  return (
    <div className={styles["item-tag-container"]}>
      <div className={styles["item-tags-item"]}>
        <ItemLocalizationSummary
          title={item.title}
          sku={item.sku}
          tagsQuantity={quantity}
          node={item.location ? item.location.node.name : i18n.t("without.branch")}
          location={item.location ? item.location.path_name : i18n.t("without.location")}
        />
      </div>
      <div className={styles["item-tags-tags"]}>
        {item.tags.length > 0 &&
          item.tags.map((tag) => {
            return (
              <Tag
                key={tag.tag}
                tag={tag}
                epc={tag.epc}
                handleDelete={handleDelete}
                type={type}
              />
            );
          })}
      </div>
    </div>
  );
};

export default ItemLocalization;
